export default (t) => {
    return [
        {
            header: t('Query'),
            accessor: 'query',
            parser: (data) => data.map((q) => q.domain).join(', ')
        },
        {
            header: t('Protocol'),
            accessor: 'proto'
        },
        {
            header: t('Local Address'),
            accessor: 'local_addr'
        },
        {
            header: t('Local Port'),
            accessor: 'local_port'
        },
        {
            header: t('Remote Address'),
            accessor: 'remote_addr'
        },
        {
            header: t('Remote Port'),
            accessor: 'remote_port'
        },
        {
            header: t('Destination'),
            accessor: 'dst'
        },
        {
            header: t('TX Bytes'),
            accessor: 'tx_bytes'
        },
        {
            header: t('TX Packets'),
            accessor: 'tx_packets'
        },
        {
            header: t('RX Bytes'),
            accessor: 'rx_bytes'
        },
        {
            header: t('RX Packets'),
            accessor: 'rx_packets'
        },
        {
            header: t('Time'),
            accessor: 'time'
        }
    ];
};
